<template>
	<div class="footer">
		<template v-if="headerShow">
			<div class="footer_box">
				<div class="footer_box_one">
					<div class="footer_box_one_one" @click="goIndex">
						<img :src="site_bottom_logo" />
					</div>
					<div class="footer_box_one_two">
						<div class="footer_box_one_two_title">{{ $t('i18n_335') }}</div>
						<div class="footer_box_one_two_child">
							<div v-for="(item, index) in product" :key="index" @click="goPathTo(item)">
								{{ item.name }}
							</div>
						</div>
					</div>
					<div class="footer_box_one_two">
						<div class="footer_box_one_two_title">{{ $t('i18n_336') }}</div>
						<div class="footer_box_one_two_child">

							<template v-for="(item, index) in company">
								<div v-if="item.value !== 'zxns' || item.value == 'zxns' && locale == 'zh'" :key="index"
									@click="goPath(item)">
									{{ item.name }}
								</div>
							</template>

						</div>
					</div>
					<div class="footer_box_one_two">
						<div class="footer_box_one_two_title">{{ $t('i18n_337') }}</div>
						<div class="footer_box_one_two_childTwo">
							<div v-for="(item, index) in contact" :key="index">
								{{ item.name }}
							</div>
						</div>
					</div>
				</div>
				<div class="footer_box_two">
					<!-- :style="locale=='zh'?'':'flex: 1;'" -->
					<div class="footer_box_two_one">
						<div>
							{{filing.filing_information_1 }}
						</div>
						<div class="footer_beian">
							<div class="footer_beian_for" v-for="(item,index) in recordBottom" :key="index"
								@click="goNewUrl(item)">
								<div class="footer_beian_for_icon" v-if="item.icon">
									<img :src="item.icon" />
								</div>
								<div class="footer_beian_for_con">
									{{item.content}}
								</div>
							</div>
						</div>
					</div>
					<div class="footer_box_two_two">
						<div>
							<img :src="filing.filing_icon" />
						</div>
						<div>{{ filing.filing_number }}</div>
					</div>
					<div class="footer_box_two_img">
						<el-popover placement="top-start" title="" width="114px" trigger="hover" content="">
							<img src="@/assets/footer/wechat.png" slot="reference" style="margin-right: 14px;" />
							<img :src="wechatLogo" style="width: 114px;height: 114px;" />
						</el-popover>
						<img src="@/assets/footer/in.png" @click="goLink(1)" />
						<img src="@/assets/footer/Facebook.png" @click="goLink(2)" />
						<img src="@/assets/footer/twitter.png" @click="goLink(3)" />
						<img src="@/assets/footer/youtobe.png" @click="goLink(4)" />
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="footer_box footer_h5_box">
				<div class="footer_box_one">
					<div class="footer_box_one_two">
						<div class="footer_box_one_two_title">{{ $t('i18n_336') }}</div>
						<div class="footer_box_one_two_child">

							<template v-for="(item, index) in company">
								<div v-if="item.value !== 'zxns' || item.value == 'zxns' && locale == 'zh'" :key="index"
									@click="goPath(item)">
									{{ item.name }}
								</div>
							</template>

						</div>
					</div>
					<div class="footer_box_one_two">
						<div class="footer_box_one_two_title">{{ $t('i18n_335') }}</div>
						<div class="footer_box_one_two_child">
							<div v-for="(item, index) in product" :key="index" @click="goPathTo(item)">
								{{ item.name }}
							</div>
							<div style="opacity: 0;">1</div>
						</div>
					</div>
					<div class="footer_box_one_one" @click="goIndex">
						<img :src="site_bottom_logo" />
					</div>
					<div class="footer_box_one_two">
						<div class="footer_box_one_two_title">{{ $t('i18n_337') }}</div>
						<div class="footer_box_one_two_childTwo">
							<div v-for="(item, index) in contact" :key="index">
								{{ item.name }}
							</div>
						</div>
					</div>
					<el-row :gutter="10" v-if="false">
						<el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
							<div class="footer_box_one_two">
								<div class="footer_box_one_two_title">{{ $t('i18n_336') }}</div>
								<div class="footer_box_one_two_child">

									<template v-for="(item, index) in company">
										<div v-if="item.value !== 'zxns' || item.value == 'zxns' && locale == 'zh'"
											:key="index" @click="goPath(item)">
											{{ item.name }}
										</div>
									</template>

								</div>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
							<div class="footer_box_one_two">
								<div class="footer_box_one_two_title">{{ $t('i18n_335') }}</div>
								<div class="footer_box_one_two_child">
									<div v-for="(item, index) in product" :key="index" @click="goPathTo(item)">
										{{ item.name }}
									</div>
									<div style="opacity: 0;">1</div>
								</div>
							</div>
						</el-col>

						<el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
							<div class="footer_box_one_one" @click="goIndex">
								<img :src="site_bottom_logo" />
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
							<div class="footer_box_one_two">
								<div class="footer_box_one_two_title">{{ $t('i18n_337') }}</div>
								<div class="footer_box_one_two_childTwo">
									<div v-for="(item, index) in contact" :key="index">
										{{ item.name }}
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="footer_box_two">
					<!-- :style="locale=='zh'?'':'flex: 1;'" -->
					<el-row :gutter="10">
						<el-col :xs="24" :sm="12" :md="16" :lg="16" :xl="16">
							<el-row :gutter="10">
								<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
									<div class="footer_box_two_one">
										<div>
											{{filing.filing_information_1 }}
										</div>
										<div class="footer_beian">
											<div class="footer_beian_for" v-for="(item,index) in recordBottom"
												:key="index" @click="goNewUrl(item)">
												<div class="footer_beian_for_icon" v-if="item.icon">
													<img :src="item.icon" />
												</div>
												<div class="footer_beian_for_con">
													{{item.content}}
												</div>
											</div>
										</div>
									</div>
								</el-col>
								<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
									<div class="footer_box_two_two">
										<div>
											<img :src="filing.filing_icon" />
										</div>
										<div>{{ filing.filing_number }}</div>
									</div>
								</el-col>
							</el-row>
						</el-col>

						<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
							<div class="footer_box_two_img">
								<el-popover placement="top-start" title="" width="114px" trigger="hover" content="">
									<img src="@/assets/footer/wechat.png" slot="reference"
										style="margin-right: 14px;" />
									<img :src="wechatLogo" style="width: 114px;height: 114px;" />
								</el-popover>
								<img src="@/assets/footer/in.png" @click="goLink(1)" />
								<img src="@/assets/footer/Facebook.png" @click="goLink(2)" />
								<img src="@/assets/footer/twitter.png" @click="goLink(3)" />
								<img src="@/assets/footer/youtobe.png" @click="goLink(4)" />
							</div>
						</el-col>
					</el-row>



				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import {
		get_config,
		get_bottom_record_config
	} from "@/api/config.js"
	export default {
		components: {

		},
		data() {
			return {
				product: [{
						name: this.$t('i18n_338'),
						value: 'njxt',
						path: 'product'
					},
					{
						name: this.$t('i18n_339'),
						value: 'dznj',
						path: 'product'
					},
					{
						name: this.$t('i18n_340'),
						value: 'zbcp',
						path: 'product'
					},
				],
				company: [{
						name: this.$t('i18n_341'),
						value: 'gyah',
						path: '/about'
					},
					{
						name: this.$t('i18n_342'),
						value: 'tzzgx',
						path: '/abInvest'
					},
					{
						name: this.$t('i18n_343'),
						value: 'xwzx',
						path: '/news'
					},
					{
						name: this.$t('i18n_344'),
						value: 'zxns',
						path: '/recruit'
					},
				],
				contact: [{
						// name:'上海市闵行区光中路133弄66号',
						name: '',
					},
					{
						// name:'400-9210-114'
						name: ''
					}
				],
				filing: {
					// filing_information_1:'Copyright © 2023 上海澳华内镜股份有限公司 保留所有权利 丨  沪ICP备17034450号-1',
					// filing_number:'沪公网安备31011202014555号',
					// filing_icon:require('@/assets/footer/beian.png')
					filing_information_1: '',
					filing_number: '',
					filing_icon: require('@/assets/footer/beian.png')
				},
				// site_bottom_logo:require('@/assets/footer/logo.png'),
				site_bottom_logo: '',
				wechatLogo: '',
				locale: 'zh',
				config: '',
				recordBottom: [],
				// headerShow:false
			}
		},
		mounted() {
			this.locale = this.$i18n.locale;
			console.log(this.$i18n.locale)
			this.getConfigList();
			this.recordBottom = localStorage.getItem('configRecordBottom');
			this.getRecordBottom();
			let aa = localStorage.getItem('configData');
			let configData = aa ? JSON.parse(aa) : '';
			this.contact[0].name = configData.contact_address;
			this.contact[1].name = configData.contact_number;
			this.filing.filing_information_1 = configData.filing_information_1;
			this.filing.filing_number = configData.filing_number;
			this.filing.filing_icon = configData.filing_icon;
			this.wechatLogo = configData.wechat_qecode
			this.config = configData;
			if (configData.site_bottom_logo) {
				this.site_bottom_logo = configData.site_bottom_logo;
			} else {
				if (this.locale == 'zh') {
					this.site_bottom_logo =
						'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/%E5%8D%B0%E5%B0%BC%E5%BE%8B%E6%89%80/20230411/%E6%BE%B3%E5%8D%8E%E5%86%85%E9%95%9C%20LOGO%20%E8%93%9D%E8%89%B2%20%E6%8B%B7%E8%B4%9D%403x.png';
				} else {
					this.site_bottom_logo = 'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/2023061401578/3.png'
				}
			}
			// if(this.locale=='zh'){
			// 	this.contact[0].name='上海市闵行区光中路133弄66号';
			// 	this.contact[1].name='400-9210-114';
			// 	this.filing.filing_information_1='Copyright © 2023 上海澳华内镜股份有限公司 保留所有权利 丨  沪ICP备17034450号-1';
			// 	this.filing_number='沪公网安备31011202014555号';
			// 	this.site_bottom_logo=require('@/assets/footer/logo.png')
			// }else{
			// 	this.contact[0].name='No.66,Lane133,Guangzhong Road, Minhang District,Shanghai,China';
			// 	this.contact[1].name='400-9210-114';
			// 	this.filing.filing_information_1='Copyright © 2023 Aohua Endoscopy Co., Ltd. All Rights Reserved';
			// 	this.filing_number='沪公网安备31011202014555号';
			// 	this.site_bottom_logo='https://aohuacbi.oss-cn-qingdao.aliyuncs.com/2023061401578/3.png'
			// }
		},
		methods: {
			goNewUrl(item) {
				console.log(item)
				if (item.type != 0) {
					window.open(item.url, '_blank')
				}
			},
			goIndex() {
				let t = this;
				var element;
				if (this.nowVibe == 'pc') {
					element = document.documentElement
				} else {
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				if (t.$route.path == '/en' || t.$route.path == '/cn') {
					// document.documentElement.scrollTop = 0
					element.scrollTop = 0;
					return
				}
				if (t.$route.path != '/') {
					if (this.locale == 'zh') {
						t.$router.push('/cn')
					} else {
						t.$router.push('/en')
					}
				} else {
					element.scrollTop = 0;
					// document.documentElement.scrollTop = 0
				}
			},
			goPath(item) {
				let t = this;
				if (!item.path) {
					return
				}
				console.log(item.path)
				if (t.$route.path != item.path) {
					t.$router.push(item.path)
				}
			},
			// 用户点击菜单栏
			goPathTo(item) {
				let t = this;
				if (!item.path) {

					return
				}
				console.log(item.path)
				if (t.$route.path != item.path) {
					t.$router.push({
						push: '/' + item.path,
						name: item.path,
						query: {
							value: item.value
						}
					})
				} else {
					t.$router.replace({
						push: '/' + item.path,
						name: item.path,
						query: {
							value: item.value
						}
					})
				}
			},
			getConfigList() {
				let data = {};
				get_config(data).then(res => {
					console.log(res)
					this.contact[0].name = res.data.contact_address;
					this.contact[1].name = res.data.contact_number;
					this.filing.filing_information_1 = res.data.filing_information_1;
					this.filing.filing_number = res.data.filing_number;
					this.filing.filing_icon = res.data.filing_icon;
					this.site_bottom_logo = res.data.site_bottom_logo;
					this.wechatLogo = res.data.wechat_qecode
					this.config = res.data
					localStorage.setItem('configData', JSON.stringify(res.data))
				}).catch(err => {
					console.log(err)
				})
			},
			getRecordBottom() {
				let data = {};
				get_bottom_record_config(data).then(res => {
					console.log(res)
					this.recordBottom = res.data
					localStorage.setItem('configRecordBottom', JSON.stringify(res.data))
				}).catch(err => {
					console.log(err)
				})
			},

			goLink(e) {
				let t = this;
				let url = ''
				switch (e) {
					case 1: {
						url = t.config.in
						break;
					}
					case 2: {
						url = t.config.FaceBook
						break;
					}
					case 3: {
						url = t.config.twitter
						break;
					}
					case 4: {
						url = t.config.YouToBe
						break;
					}
				}
				window.open(url, '_blank')
			}
		}
	}
</script>

<style>
	.el-popover {
		min-width: auto !important;
	}
</style>
<style scoped lang="scss">
	.footer {
		width: 100%;
		background: #333333;

		.footer_box {
			width: 1200px;
			padding-top: 76px;
			padding-bottom: 47px;
			margin: 0 auto;

			.footer_box_one {
				display: flex;

				.footer_box_one_one {
					margin-right: 116px;

					img {
						cursor: pointer;
						width: 175px;
						height: 30px;
						// width: 92px;
						// height: 32px;
					}
				}

				.footer_box_one_two {
					margin-right: 116px;

					.footer_box_one_two_title {
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
						margin-bottom: 18px;
					}

					.footer_box_one_two_child {
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #9A9A9A;

						>div {
							cursor: pointer;
							margin-bottom: 18px;
						}
					}

					.footer_box_one_two_childTwo {
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #9A9A9A;

						>div {
							margin-bottom: 18px;
						}
					}
				}
			}

			.footer_box_two {
				display: flex;
				margin-top: 20px;
				border-top: 1px solid #9A9A9A;
				padding-top: 20px;

				.footer_box_two_one {
					font-size: 12px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #9A9A9A;
					margin-right: 88px;
				}

				.footer_box_two_two {
					display: flex;
					flex: 1;

					>div:nth-of-type(1) {
						margin-right: 6px;

						img {
							width: 15px;
							height: 15px;
						}
					}

					>div:nth-of-type(2) {
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #9A9A9A;
					}
				}

				.footer_box_two_img {
					img:not(:last-child) {
						margin-right: 14px;
					}

					img {
						cursor: pointer;
						width: 20px;
						height: 20px;
					}
				}
			}
		}
	}

	[lang]:lang(en) {
		.footer_box_one_two {
			margin-right: 30px !important;

		}
	}

	[lang]:lang(eu) {
		.footer_box_one_two {
			margin-right: 30px !important;

		}
	}

	@media screen and (max-width:1200px) {
		.footer_h5_box {
			max-width: 100vw;
			width: auto !important;
			padding: 0 20px;
			padding-left: 50px;
			box-sizing: border-box;

			.footer_box_one {
				width: 100%;
				flex-wrap: wrap;
				align-items: stretch;
			}

			.footer_box_one_one {
				width: calc(50% - 10px);
				margin-right: 10px !important;
				display: flex;
				align-items: flex-end;

				img {
					cursor: pointer;
					// width: 175px;
					width: auto !important;
					height: 22px !important;
					object-fit: contain;
					// width: 92px;
					// height: 32px;
				}
			}

			.footer_box_one_two {
				width: 50%;
				margin-right: 0 !important;

				.footer_box_one_two_childTwo {
					word-wrap: break-word !important;
					word-break: break-all !important;

					>div:last-child {
						margin-bottom: 0 !important;
					}
				}
			}

			.footer_box_two_one {
				margin-right: 20px !important;
			}
		}

	}

	.footer_beian {
		display: flex;
		margin-top: 11px;

		.footer_beian_for {
			cursor: pointer;
			line-height: 18px;
			margin-right: 49px;
			font-size: 12px;
			color: #9a9a9a;
			display: flex;
			align-items: center;

			.footer_beian_for_icon {

				// margin-right: 10px;
				img {
					width: 18px;
					height: 18px;
					display: inline-block;
					vertical-align: top;
					margin-right: 5px;
				}

			}

			.footer_beian_for_con {}
		}
	}
</style>